export default __webpack_public_path__ + "static/media/iconOutbound.68844e74.svg";